import { useEffect, useState } from "react";
import { Link } from "react-router";
import { Button } from "@bloom/ui";
import { api } from "../api/client.ts";

interface Series {
  _id: string;
  slug: string;
  titleTh: string;
  titleEn: string;
  published: boolean;
  featured: boolean;
}

export function SeriesIndex() {
  const [items, setItems] = useState<Series[]>([]);
  useEffect(() => {
    void api.get<{ items: Series[] }>("/api/admin/series").then((d) => setItems(d.items));
  }, []);
  return (
    <div className="space-y-6">
      <header className="flex items-baseline justify-between">
        <h1 className="font-heading text-3xl font-bold">Series</h1>
        <Link
          to="/series/new"
          className="inline-flex h-10 items-center rounded-full bg-[var(--brand-ink)] px-4 text-sm font-semibold text-[var(--brand-paper)]"
        >
          + New
        </Link>
      </header>
      <table className="w-full text-sm">
        <thead className="text-left text-[var(--brand-muted)]">
          <tr>
            <th className="py-2">Slug</th>
            <th>Title (EN)</th>
            <th>Title (TH)</th>
            <th>Published</th>
            <th>Featured</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {items.map((s) => (
            <tr key={s._id} className="border-t border-[var(--brand-border)]">
              <td className="py-2 font-mono text-xs">{s.slug}</td>
              <td>{s.titleEn}</td>
              <td>{s.titleTh}</td>
              <td>{s.published ? "✓" : "—"}</td>
              <td>{s.featured ? "★" : "—"}</td>
              <td className="text-right">
                <Link
                  to={`/series/${s._id}`}
                  className="text-sm font-semibold text-[var(--brand-rose)] hover:underline"
                >
                  Edit
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {items.length === 0 ? (
        <p className="text-sm text-[var(--brand-muted)]">No series yet.</p>
      ) : null}
    </div>
  );
}
